
import React from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import FeaturesTableLayout from '../../Layout/FeaturesTableLayout';

const SkeletonRow = styled.tr`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: ${props => props.theme.size.dynamic0040};

  @media screen and (min-width: 1025px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const SkeletonCell = styled.td`
  padding: ${({theme}) => theme.size.dynamic0040};
  height: 300px;

  @media (max-width: 1024px) {
    height: 250px;
  }
`;

const SkeletonContent = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    ${({theme}) => theme.colors.background.tertiary} 25%,
    ${({theme}) => theme.colors.background.secondary} 50%,
    ${({theme}) => theme.colors.background.tertiary} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: ${({theme}) => theme.size.borderRadius.xSmall};

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const LengthsSkeleton = () => {
  return (
    <FeaturesTableLayout
      propKey={'trim-dimension-skeleton'}
      headers={['', '', '']}
    >
      <SkeletonRow>
        {[...Array(3)].map((_, i) => (
          <SkeletonCell role="cell" key={`skeleton-length-${i}`}>
            <SkeletonContent />
          </SkeletonCell>
        ))}
      </SkeletonRow>
    </FeaturesTableLayout>
  );
};
